import React from 'react';
import Navigation from './components/Navigation'
import './css/styles.css';

function App() {
  return (
    <div id="wrapper">
      <Navigation />
    </div>
  );
}

export default App;
